import Vue from 'vue'
import Vuex from 'vuex'

import yet from './default.js'
Vue.use(Vuex)
import login from './login.js'
export default new Vuex.Store({
  modules: {
    login: login,
    yet: yet
  }
})
